import { render, staticRenderFns } from "./ProfileDeactivate.vue?vue&type=template&id=fc42d2bc&"
import script from "./ProfileDeactivate.vue?vue&type=script&lang=js&"
export * from "./ProfileDeactivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports